<template>
  <div
    class="responses-minimalist"
    :dir="$i18n.locale === 'he' ? 'rtl' : 'ltr'"
  >
    <div v-if="responses && responses.length">
      <div
        v-for="(resp, idx) in responses"
        :key="idx"
        class="resp-row-minimalist"
      >
        <v-avatar color="secondary" size="28" class="mr-2">
          <v-icon color="primary" size="20">mdi-account-circle</v-icon>
        </v-avatar>
        <span class="resp-author-minimalist">{{ resp.author }}</span>
        <span class="resp-time-minimalist">{{ resp.time }}</span>
        <span class="resp-text-minimalist">{{ resp.text }}</span>
      </div>
    </div>
    <div v-else class="empty-resp-minimalist">
      <v-icon size="32" color="info">mdi-message-off-outline</v-icon>
      <span class="ml-2">{{ $t("noResponses") }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "AlertResponses",
  props: {
    responses: { type: Array, default: () => [] },
    minimalist: Boolean,
    dir: { type: String, default: "ltr" },
  },
};
</script>
<style scoped>
.responses-minimalist {
  margin-top: 32px;
  width: 100%;
  background: none;
}
.resp-row-minimalist {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  border-bottom: 1px solid var(--v-theme-surface);
  font-size: 1.01rem;
}
.resp-row-minimalist:last-child {
  border-bottom: none;
}
.resp-author-minimalist {
  font-weight: bold;
  color: var(--v-theme-primary);
  margin-inline-end: 6px;
}
.resp-time-minimalist {
  color: var(--v-theme-secondary);
  font-size: 0.93rem;
  margin-inline-end: 8px;
}
.resp-text-minimalist {
  color: var(--v-theme-secondary);
  margin-inline-start: 8px;
}
.empty-resp-minimalist {
  display: flex;
  align-items: center;
  color: var(--v-theme-secondary);
  margin-top: 16px;
  font-size: 1.05rem;
}
</style>
